(function() { window.GUID_4781043e_079c_4f5b_998b_5e03467a8756 = { getGuid: function() { return "4781043e-079c-4f5b-998b-5e03467a8756"; } }; })();
var CompuSport;
(function (CompuSport) {
    var timeOutId = null;
    function Lag(lagTime, callback) {
        if (timeOutId != null) {
            clearTimeout(timeOutId);
        }
        timeOutId = setTimeout(callback, lagTime);
        return timeOutId;
    }
    CompuSport.Lag = Lag;
    function LagLocal(localTimeOutId, lagTime, callback) {
        if (localTimeOutId != null) {
            clearTimeout(localTimeOutId);
        }
        localTimeOutId = window.setTimeout(callback, lagTime);
        return localTimeOutId;
    }
    CompuSport.LagLocal = LagLocal;
})(CompuSport || (CompuSport = {}));

//# sourceMappingURL=Lag.js.map
